import { gql } from "@apollo/client";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  query VendorProjects($slug: String!, $cursor: Cursor, $limit: Int = 6) {
    company(slug: $slug) {
      _id
      slug
      projects(cursor: $cursor, limit: $limit) {
        items {
          ...ProjectCardFields
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }

  ${ProjectCardFieldsFragment}
`;
